import { signatureSaved } from './signatureSaved';
import SignatureOptionState from '../store/schema/SignatureOptionState';
import store from '../store/store';
import { confirm } from 'owa-confirm-dialog';
import { setMailboxMessageConfiguration } from 'owa-options-core';
import MailboxMessageConfigurationOptions from 'owa-service/lib/contract/MailboxMessageConfigurationOptions';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import { action, select } from 'satcheljs/lib/legacy';

const DATA_URI_SRC_REGEX = /(<img [^>]*)(src=["']?)(data:image\/[^<]+;base64,[a-zA-Z0-9+\/=&#;]+)(["']?)([^>]*>)/gi;
const HIDDEN_SPAN_OPENING_TAG = '<span id="dataURI" style="display:none">';
const HIDDEN_SPAN_CLOSING_TAG = '</span>';

export interface SaveSignatureOptionState {
    optionState: SignatureOptionState;
    userOptions: UserOptionsType;
}

export default select<SaveSignatureOptionState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(
    action('saveSignatureOption')(async function saveSignatureOption(
        state?: SaveSignatureOptionState
    ) {
        let { optionState, userOptions } = state;
        let serviceOptions: MailboxMessageConfigurationOptions = {};

        if (optionState.editorViewState.isDirty) {
            let signatureEditorContent = optionState.editorViewState.content;
            userOptions.SignatureHtml = signatureEditorContent;
            serviceOptions.SignatureHtml = processSignatureHtmlForImages(signatureEditorContent);

            // Reset isDirty so the save/discard buttons reset
            optionState.editorViewState.isDirty = false;
        }

        if (optionState.signNewMails !== null) {
            userOptions.AutoAddSignature = optionState.signNewMails;
            serviceOptions.AutoAddSignature = optionState.signNewMails;
        }

        if (optionState.signReplies !== null) {
            userOptions.AutoAddSignatureOnReply = optionState.signReplies;
            serviceOptions.AutoAddSignatureOnReply = optionState.signReplies;
        }

        setMailboxMessageConfiguration(serviceOptions)
            .then(() => {
                signatureSaved();
            })
            .catch(() => {
                // VSO 32094: show dialog when signature fails to save
                confirm(
                    strings.options_signature_saveFailedDialogTitle,
                    strings.options_signature_saveFailedDialogBody
                );
            });
    })
);

// XSO has a size limit for attributes, and the server will remove the src if is too long
// Instead, store src as text in a hidden span, which should not be truncated
// This is the same implementation of SignatureOptionsViewModel.ProcessSignatureHtmlForImages in jsMVVM
function processSignatureHtmlForImages(signatureHtml: string) {
    /*
        Regex matches parts of each img tag and rearranges the html so that
        the original src is moved into a span

        Example: <img src="data:image/png;base64,IMGSRCURL" style="max-width: 100%;"> ==>

        $1 = <img
        $2 = src="
        $3 = data:image/png;base64,IMGSRCURL
        $4 = "
        $5 = style="max-width: 100%;">
        <img src="" style="max-width: 100%;"><span id="dataURI" style="display:none">data:image/png;base64,IMGSRCURL</span>
    */
    return signatureHtml.replace(
        DATA_URI_SRC_REGEX,
        '$1' + '$2' + '$4' + '$5' + HIDDEN_SPAN_OPENING_TAG + '$3' + HIDDEN_SPAN_CLOSING_TAG
    );
}
